module.exports = __webpack_public_path__ + "img/cake-1.a2bd2399.svg";